import { useToast } from "@chakra-ui/react";

export const useAppToast = (opts) =>
useToast({
    position: "bottom-right",
    duration: 6000,
    isClosable: true,
    containerStyle: {
        maxWidth: "380px",
        padding: "8px",
        marginBottom: "24px",
        marginRight: "8px",
    },
    ...opts,
});
